<template>
  <div>
    <div
      class="text-xl font-light w-full flex flex-col space-y-6 text-gray-900 bg-tertiary py-8 px-8 rounded-3xl tracking-normal text-left"
    >
      <div>
        <span class="uppercase text-lg font-normal">
          <span v-if="action == 'deposit'">From </span>
          <span v-if="action == 'withdraw'">To </span>

          <span v-if="isPrimary && !isSwap">ETH</span>
          <span v-if="isSwap || !isPrimary">NFTs</span>
        </span>
      </div>
      <div class="flex justify-between items-center">
        <span v-if="isSwap">
          <SelectNftsInput :userAction="action" />
        </span>
        <span v-else>
          <SelectTokenInput v-if="isPrimary" :userAction="action" />
          <SelectNftsInput v-if="!isPrimary" :userAction="action" />
        </span>

        <div class="flex space-x-4 items-end">
          <span class="text-45px" v-if="action == 'deposit'">
            {{ deposit }}
          </span>
          <span class="text-45px" v-if="action == 'withdraw'">
            {{ withdraw }}
          </span>
          <div>
            <span v-if="isPrimary && !isSwap">ETH</span>
            <span v-if="isSwap || !isPrimary">NFTs</span>
          </div>
        </div>
      </div>
    </div>

    <!-- <SelectNfts :isType="isType" /> -->
  </div>
</template>


<script>
// for reference
//  address[] memory _decodedAddrs; // [toNft, changeIn]
//         uint256[] memory _toIds;
//         uint256[] memory _toAmounts;

/*
1) if input is "TOKEN" then
    a. Input the token type you are going to pay with, eth, muse ,usdc, meme20, etc
    b. Pick the nfts you want out, they have to be from same project.
    c. auto input tokens amount required to execute the swap

2) if user input NFT then:
    a. Pick nfts, if erc721 has to be 1, they have to be from same project/nft address
    b. Pick if you want tokens (easy), or if you want another NFTs from 1 specific project


*/
import BigNumber from "bignumber.js";
import SelectNftsInput from "@/components/cas/SelectNftsInput";
import SelectTokenInput from "@/components/cas/SelectTokenInput";
import axios from "axios";

export default {
  name: "InputAsset",
  components: { SelectNftsInput, SelectTokenInput },
  props: {
    action: String,
    isSwap: Boolean,
    isPrimary: Boolean,
  },
  data: function () {
    return {
      nftValue: 0,
      picked: "tokens",
      pricePerToken: 0,
      pricePerTokenComputed: 0,
    };
  },
  beforeMount: async function () {},
  methods: {
    // getPrice: async function (tokenAddr, nftsQty) {
    //   const amount = 100000000000000000000 * nftsQty * 1.03;
    //   console.log("token address ", tokenAddr);
    //   let price = await axios.get(
    //     `https://api.1inch.exchange/v2.0/quote?fromTokenAddress=${tokenAddr}&toTokenAddress=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee&amount=${amount}`
    //   );
    //   console.log(price);
    //   console.log("price ", price.data.toTokenAmount);
    //   this.pricePerToken = price.data.toTokenAmount;
    //   console.log(this.pricePerToken);
    // },
  },
  mounted: async function () {},
  watch: {},
  asyncComputed: {
    withdraw: function () {
      if (this.isPrimary) {
        if (this.$store.state.casPrice) {
          const amount = new BigNumber(this.$store.state.casPrice)
            .shiftedBy(-parseInt(18))
            .toFixed(2, 1);

          console.log("amount ", amount);
          return amount;
        } else {
          return 0;
        }
      } else {
        if (this.$store.state.casPrice) {
          return this.$store.state.casWithdraw.totalQty;
        } else {
          return 0;
        }
      }
    },
    deposit: function () {
      if (this.isPrimary) {
        if (this.$store.state.casPrice) {
          const amount = new BigNumber(this.$store.state.casPrice)
            .shiftedBy(-parseInt(18))
            .toFixed(2, 1);
          console.log("amount ", amount);

          return amount;
        } else {
          return 0;
        }
      } else {
        if (this.$store.state.casPrice) {
          return this.$store.state.casDeposit.totalQty;
        } else {
          return 0;
        }
      }

      // if (this.$store.state.casDeposit && this.action == "deposit") {
      //   if (
      //     (!this.isSwap && this.$store.state.casDeposit.schema == 721) ||
      //     this.$store.state.casDeposit.schema == 1155
      //   ) {
      //     for (
      //       var i = 0;
      //       i < this.$store.state.casDeposit.nfts.qty.length;
      //       i++
      //     ) {
      //       qty += parseInt(this.$store.state.casDeposit.nfts.qty[i]);
      //     }
      //   }
      // }

      // return qty;
    },

    account: function () {
      return this.$store.state.account;
    },
  },
};
</script>

